import Vuex from 'vuex';
import Vue from 'vue';
import app from './modules/app';
import dataManagement from './modules/data-management';
import leftNavCustomization from './modules/left-nav-customization';
import user from './modules/user/index';
import sunModel from './modules/sun-model/index';
import monitoring from './modules/monitoring';
import connectorScreen from './modules/connector-screen';
import mdmModel from './modules/mdm-model';
import loanCalculator from './modules/loan-calculator';
import systemInfo from './modules/system-info';
import fileManipulationController from './modules/file-manipulation-controller';
import sidebar from './modules/sidebar-configuration';
import designer from './modules/designer';
import tags from './modules/tags';
import dataQuality from './modules/data-quality';
import dataGovernance from './modules/data-governance';
import dataCatalog from './modules/data-catalog';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    dataQuality,
    dataCatalog,
    tags,
    sidebar,
    designer,
    app,
    user,
    sunModel,
    dataManagement,
    monitoring,
    connectorScreen,
    mdmModel,
    fileManipulationController,
    loanCalculator,
    systemInfo,
    leftNavCustomization,
    dataGovernance,
  },
});
